import { takeEvery, put, call } from "redux-saga/effects"

// Calender Redux States
import {
  GET_USER,
  GET_USER_DETAILS,
  ADD_NEW_USER,
  UPDATE_USER,
  DELETE_USER,
  EXPORT_USER_EXCEL,
  UPDATE_ACTIVATION_USER,
  UPDATE_DEPARTMENT_USER,
} from "./actionTypes";

import {
  getUserSuccess,
  getUserFail,
  getUserDetailsSuccess,
  getUserDetailsFail,
  addUserFail,
  addUserSuccess,
  updateUserSuccess,
  updateUserFail,
  deleteUserSuccess,
  deleteUserFail,
  exportUserExcelSuccess,
  exportUserExcelFail,
  updateActivationUserSuccess,
  updateActivationUserFail,
  updateDepartmentUserSuccess,
  updateDepartmentUserFail,
} from "./actions"

import {
  userListingApi,
  userDetailsApi,
  addNewUser,
  updateUser,
  delUser,
  exportAdmin,
  updateActivationUser,
  updateDepartmentUser
} from "./userApi.js"

function* fetchUser({ payload: user }) {
  try {
    const response = yield call(userListingApi, user)
    yield put(getUserSuccess(response))
  } catch (error) {
    yield put(getUserFail(error))
  }
}

function* fetchUserDetails({ payload }) {
  try {
    const response = yield call(userDetailsApi, payload)
    yield put(getUserDetailsSuccess(response))
  } catch (error) {
    yield put(getUserDetailsFail(error))
  }
}

function* onAddNewUser({ payload: user }) {
  try {
    const response = yield call(addNewUser, user)
    yield put(addUserSuccess(response))
  } catch (error) {
    yield put(addUserFail(error))
  }
}

function* onUpdateUser({ payload: id, user }) {
  try {
    const response = yield call(updateUser, id, user)
    yield put(updateUserSuccess(response))
  } catch (error) {
    yield put(updateUserFail(error))
  }
}

function* onUpdateUserActivation({ payload: id, user }) {
  try {
    const response = yield call(updateActivationUser, id, user)
    yield put(updateActivationUserSuccess(response))
  } catch (error) {
    yield put(updateActivationUserFail(error))
  }
}

function* onUpdateUserDepartment({ payload }) {
  try {
    const response = yield call(updateDepartmentUser, payload)
    yield put(updateDepartmentUserSuccess(response))
  } catch (error) {
    yield put(updateDepartmentUserFail(error))
  }
}

function* onDelUser({ payload }) {
  try {
    const response = yield call(delUser, payload)
    yield put(deleteUserSuccess(response))
  } catch (error) {
    yield put(deleteUserFail(error))
  }
}

function* onExportUserExcel({ payload }) {
  try {
    const response = yield call(exportAdmin, payload)
    yield put(exportUserExcelSuccess(response))
  } catch (error) {
    yield put(exportUserExcelFail(error))
  }
}

function* UserSaga() {
  yield takeEvery(GET_USER, fetchUser)
  yield takeEvery(GET_USER_DETAILS, fetchUserDetails)
  yield takeEvery(ADD_NEW_USER, onAddNewUser)
  yield takeEvery(UPDATE_USER, onUpdateUser)
  yield takeEvery(UPDATE_ACTIVATION_USER, onUpdateUserActivation)
  yield takeEvery(UPDATE_DEPARTMENT_USER, onUpdateUserDepartment)
  yield takeEvery(DELETE_USER, onDelUser)
  yield takeEvery(EXPORT_USER_EXCEL, onExportUserExcel)

}

export default UserSaga
